import React, { useEffect, useState, createContext, useContext } from 'react';
export type Language = 'es' | 'en';
const commonTranslations = {
  es: {
    nav: {
      inicio: 'Inicio',
      servicios: 'Servicios',
      portfolio: 'Portafolio',
      sobre: 'Sobre mí',
      faq: 'FAQ',
      contact: 'Contacto',
      cta: 'Da el primer paso',
      menu: 'Menú'
    }
  },
  en: {
    nav: {
      inicio: 'Home',
      servicios: 'Services',
      portfolio: 'Portfolio',
      sobre: 'About me',
      faq: 'FAQ',
      contact: 'Contact',
      cta: 'Take the first step',
      menu: 'Menu'
    }
  }
};
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: typeof commonTranslations.es;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  // Initialize from localStorage if available
  const [lang, setLangState] = useState<Language>(() => {
    try {
      const savedLang = localStorage.getItem('inkova_lang');
      if (savedLang === 'es' || savedLang === 'en') {
        return savedLang;
      }
    } catch (e) {
      // Ignore
    }
    return 'es';
  });
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    try {
      localStorage.setItem('inkova_lang', newLang);
    } catch (e) {
      // Ignore
    }
  };
  const t = commonTranslations[lang];
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-490">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}